"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VideosHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="videos-hero" className="relative w-full bg-background py-32 md:py-48">
      <div ref={ref} className="mx-auto max-w-7xl px-6 text-center">
        <h1 className={`font-display text-6xl md:text-8xl font-extralight uppercase tracking-widest text-foreground transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          Videos
        </h1>
        <p className={`mt-6 text-lg md:text-xl font-medium text-muted-foreground transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>page in development</p>
      </div>
    </section>;
}